export const FETCH_NOTIFICATIONS_TIMEOUT = 600000;
